app.controller('BrowseProductIndividualWrapController', ['$rootScope', '$scope', function ($rootScope, $scope) {

    const navigationIDs = $scope.navigation_ids;
    const productModel = $rootScope.factory.product_wrap.getModel(navigationIDs);
    let product;

    $scope.product_model = productModel;
    $scope.product = null;

    const documentProductTag = "wrap";

    $scope.product_document = null;
    $rootScope.service.cache_local_server.productDocumentsByTags([navigationIDs.site_range_id, documentProductTag], function (documents) {
        $scope.product_document = documents.length > 0 ? documents[0] : null;
    })

    function applyProduct() {
        product = productModel.product;
        $scope.product = product;
    }

    applyProduct();
    productModel.apiRequire(applyProduct)

    $scope.addToCartHandler = function (validateFormCallback, product) {
        const categoryCartID = $scope.category_cart_id ? $scope.category_cart_id : null;

        const complexOption = $rootScope.service.option_product.currentComplexOption(product);

        const orderLine = {

            type: product.api_code,
            product_code: product.api_code,

            quantity: product.quantity,
            cost: product.displayPrice(),

            range: product.getSubmitRangeID(),
            colour: navigationIDs.colour_id,
            style: navigationIDs.style_id,

            option_id: complexOption.id,

            height: product.height,
            width: product.width,
            depth: product.depth,
            return: product.return,

            rotate_grain: product.rotate_grain,

            category_cart_id: categoryCartID,

            product_model_id: product.model_id,
            parent_category_ids: product.parent_category_ids,

            group_name: product.group_name
        };

        console.log("orderLine")
        console.log(orderLine)

        const orderBuild = {
            range: orderLine.range,
            colour: orderLine.colour,
            style: orderLine.style,
            lines: [orderLine]
        };

        $rootScope.service.product.addToCart(orderBuild, function (success, messages) {
            if (success) {

                $rootScope.service.product.resetProduct(product);

                product.panelThickness = '';
                product.applynonstdsurcharge = false;
                product.return = '';

            }
            if (validateFormCallback) {
                validateFormCallback(success, messages);
            }
        });
    };

}]);